import React, { useMemo } from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import Carousel from '../carousel';
import { STATIC_ASSET_URL } from '../../utils/content-templates';
import StylePackItem from './style-pack-item';
import { ContentTemplate, StylePackData, StylePackGroup, StylePackItemTypes } from '../types/stylepacks';
import { filteredSkele } from './skeleton-sizes';

// TODO: need to add more definition to this
export interface StylePackProps {
	id: string;
	name: string;
	locked?: boolean;
	content: StylePackGroup[];
	setStylePackInfo: (stylePackInfo: StylePackData, id: string) => void;
	filter?: string;
	forceLoadImmediate?: boolean;
}

export function getAssetURL(url: string) {
	return url.replace('ASSET_URL', STATIC_ASSET_URL);
}

export default function StylePack(props: StylePackProps) {
	const {
		id,
		name,
		content = [],
		locked = false,
		setStylePackInfo,
		filter,
	} = props;

	function clickViewStyle() {
		setStylePackInfo({
			id,
			name,
			locked,
			stylePack: content,
		}, '');
	}

	function itemClicked(item: any) {
		setStylePackInfo({
			id,
			name,
			locked,
			stylePack: content,
		}, item.id);
	}

	const packTemplates: ContentTemplate[] = useMemo(() => {
		return content.flatMap(item => item.templates);
	}, [content]);

	const filteredTemplates: ContentTemplate[] = useMemo(() => {
		if (!filter) return packTemplates;

		return packTemplates.filter((template) => template.contentType === filter);
	}, [packTemplates, filter]);

	return (
		<div
			className="style-pack"
			data-testid="style-pack"
			key={`style-pack-filter-${id}`}
			onClick={clickViewStyle}
		>
			<div
				className="style-pack-header"
				data-testid="style-pack-header"
			>
				<div
					className="style-pack-header-title"
					data-testid="style-pack-header-title"
				>
					{name}
				</div>
				<div
					className="style-pack-view-style"
					data-testid="style-pack-view-style"
				>
					<div>
						{filter ? 'View Style' : 'See all'}
					</div>
				</div>
			</div>
			
			{filter ? <div className='style-pack-filtered-list'>
				{filteredTemplates.map((item) => <StylePackItem
					key={`style-pack-filtered-item${item.id}`}
					item={item}
					type={StylePackItemTypes.Info}
				/>)}
			</div> : null}

			{filter ? null : <Carousel
				id={id}
				list={packTemplates}
				onClick={itemClicked}
			/>}
		</div>
	);
}
